import React from 'react'
import BoxOneFieldGoodSelect from '../fields/BoxOneFieldGoodSelect'
import { useDispatch, useSelector } from 'react-redux'
import { setBoxGoodId } from '../../../../store/boxSlice'

const BoxOneOptions = ({ boxId }) => {

    const goodId = useSelector(state => state.box.goodId)
    const dispatch = useDispatch()

  return (
    <div>
         <BoxOneFieldGoodSelect 
            boxId={boxId}
            required={false}
            setValidate={e => {}}
            setValueForm={e => dispatch(setBoxGoodId(e))}
            forciblyValue={goodId ? goodId : ''}
        />
    </div>
  )
}

export default BoxOneOptions